import Model from "./Model";

export default class extends Model {
    async loadTable(page, limit, search = '') {
        let response = await super.list(page, limit, search).then(result => {return result});
        let result = {
            tbody: [],
            pages: response.pages,
        };
        if(response.items !== undefined && response.items.length > 0)
        {
            response.items.forEach(repository => {
                let telem = {
                    tbody: {}
                };
                telem.id = repository.id;
                telem.tbody.repository_path = repository.repository_path;
                result.tbody.push(telem);
            });
        }
        return result;
    }
}
